export default "__VITE_ASSET__BLXrrKlG__"